import React, { useEffect } from 'react';
import AbcNotation from './AbcNotation';
import { cleanAndFillAbc } from '../utils/cleanAndFillAbc';
import { normalizeType, normalizeKey } from '../utils/normalize';

export default function AbcImportPreview({
  importedTune,
  setImportedTune,
  importFields,
  customAbcOverride,
  setCustomAbcOverride,
  setOriginalAbc,
  abcCompact = true
}) {
  // Clean and infer ABC headers on version change
  useEffect(() => {
    if (importedTune?.versions?.length) {
      const raw = importedTune.versions[importedTune.selectedIndex]?.abc || '';

      const cleaned = cleanAndFillAbc({
        rawAbc: raw,
        type: normalizeType(importedTune.type),
        key: normalizeKey(importedTune.key)
      });


      setCustomAbcOverride(cleaned);
      setOriginalAbc(cleaned);
    }
  }, [importedTune?.selectedIndex]);

  if (!importFields.abc || !importedTune?.versions?.length) return null;

  return (
      <div style={{ marginTop: '10px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '8px',
        flexWrap: 'wrap',
        textAlign: 'center'
      }}>
       <button
        className="btn-subtle search-control-btn"
        onClick={() =>
          setImportedTune(prev => ({
            ...prev,
            selectedIndex:
              (prev.selectedIndex - 1 + prev.versions.length) % prev.versions.length
          }))
        }
      >
        ◀ Prev
      </button>

     <span style={{ fontSize: 'var(--ui-compact-font)', fontWeight: 600 }}>
  Version {importedTune.selectedIndex + 1} of {importedTune.versions.length}
</span>

<button
  className="btn-subtle search-control-btn"
  onClick={() =>
    setImportedTune(prev => ({
      ...prev,
      selectedIndex: (prev.selectedIndex + 1) % prev.versions.length
    }))
  }
>
  Next ▶
</button>


      </div>

      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '0.6rem' }}>
        <AbcNotation abc={customAbcOverride} compact={abcCompact} />
      </div>
    </div>
  );
}
